module.exports = __webpack_public_path__ + "img/no-winner.5e326935.png";